import { Injectable } from '@angular/core'
import {
  ApiResult,
  formatSettingsTabLabel,
  ResourceSettingsLayoutService,
  ResourceSettingsLayoutViewModel,
} from '@ftr/foundation'
import { AppPaths } from '@ftr/routing-paths'

export enum AccountSettingsTabs {
  General = 'general',
  Security = 'security',
  SavedCards = 'saved-cards',
}

@Injectable()
export class AccountSettingsLayoutService implements ResourceSettingsLayoutService {
  buildViewModel(): ApiResult<ResourceSettingsLayoutViewModel> {
    const accountSettingsBaseUrl = ['/', AppPaths.Account]

    const tabs = [
      {
        label: formatSettingsTabLabel(AccountSettingsTabs.General),
        value: AccountSettingsTabs.General,
        routerUrl: accountSettingsBaseUrl,
        routerParams: { tab: AccountSettingsTabs.General },
      },
      {
        label: formatSettingsTabLabel(AccountSettingsTabs.Security),
        value: AccountSettingsTabs.Security,
        routerUrl: accountSettingsBaseUrl,
        routerParams: { tab: AccountSettingsTabs.Security },
      },
      {
        label: formatSettingsTabLabel(AccountSettingsTabs.SavedCards),
        value: AccountSettingsTabs.SavedCards,
        routerUrl: accountSettingsBaseUrl,
        routerParams: { tab: AccountSettingsTabs.SavedCards },
      },
    ]

    return ApiResult.success({ title: 'Account', tabs })
  }
}
